<div class="space-y-6">
  <app-page-header
    [backTo]="['/payment-methods']"
    backLabel="Retour aux méthodes"
  >
    @if (item(); as m) {
      <div slot="actions" class="flex flex-wrap items-center gap-2">
        <a
          [routerLink]="['/payment-methods', m.id, 'edit']"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
        >
          Modifier
        </a>
        <button
          type="button"
          (click)="openDelete()"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-error-300 px-4 py-2 text-sm font-medium text-error-700 transition hover:bg-error-50 dark:border-error-800 dark:text-error-400 dark:hover:bg-error-500/10"
        >
          Supprimer
        </button>
      </div>
    }
  </app-page-header>

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      loadingMessage="Chargement…"
      (retry)="fetch()"
    />
  } @else if (item(); as m) {
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex items-center gap-4">
          @if (m.imageUrl) {
            <img [src]="m.imageUrl" [alt]="m.name" class="h-16 w-16 rounded-xl object-contain ring-1 ring-gray-200 dark:ring-gray-800" />
          } @else {
            <span class="flex h-16 w-16 items-center justify-center rounded-xl bg-gray-100 text-base font-semibold text-gray-500 dark:bg-gray-800 dark:text-gray-400">
              {{ m.name.slice(0, 2).toUpperCase() }}
            </span>
          }
          <div>
            <h1 class="text-xl font-semibold text-gray-800 dark:text-white/90">{{ m.name }}</h1>
            <p class="font-mono text-xs text-gray-500 dark:text-gray-400">{{ m.serviceCode }}</p>
          </div>
        </div>
        @if (m.status) {
          <span class="inline-flex h-fit items-center rounded-full bg-brand-50 px-3 py-1 text-xs font-medium text-brand-700 dark:bg-brand-500/15 dark:text-brand-400">Actif</span>
        } @else {
          <span class="inline-flex h-fit items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">Inactif</span>
        }
      </div>
    </section>

    <div class="grid gap-6 lg:grid-cols-2">
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">Identification</h2>
        <dl class="mt-4 grid gap-3 text-sm">
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Nom</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ m.name }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Code service (PSP)</dt>
            <dd class="text-right font-mono text-xs text-gray-800 dark:text-white/90 break-all">{{ m.serviceCode }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Type</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ typeLabel[m.type] }}</dd>
          </div>
          @if (m.imageUrl) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">URL logo</dt>
              <dd class="text-right">
                <a [href]="m.imageUrl" target="_blank" rel="noopener" class="text-brand-600 hover:text-brand-700 dark:text-brand-400">Ouvrir</a>
              </dd>
            </div>
          }
        </dl>
      </section>

      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <h2 class="text-base font-semibold text-gray-800 dark:text-white/90">Métadonnées</h2>
        <dl class="mt-4 grid gap-3 text-sm">
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">ID interne</dt>
            <dd class="text-right font-mono text-gray-800 dark:text-white/90">#{{ m.id }}</dd>
          </div>
          <div class="flex justify-between gap-4">
            <dt class="text-gray-500 dark:text-gray-400">Créée le</dt>
            <dd class="text-right text-gray-800 dark:text-white/90">{{ m.createdAt | ldate:'dd/MM/yyyy HH:mm' }}</dd>
          </div>
          @if (m.updatedAt) {
            <div class="flex justify-between gap-4">
              <dt class="text-gray-500 dark:text-gray-400">Mise à jour</dt>
              <dd class="text-right text-gray-800 dark:text-white/90">{{ m.updatedAt | ldate:'dd/MM/yyyy HH:mm' }}</dd>
            </div>
          }
        </dl>
      </section>
    </div>
  }
</div>

<app-confirm-modal
  [open]="deleteOpen()"
  [busy]="deleting()"
  [error]="deleteError()"
  title="Supprimer cette méthode ?"
  confirmLabel="Supprimer définitivement"
  busyLabel="Suppression…"
  danger
  (confirm)="confirmDelete()"
  (close)="closeDelete()"
>
  La méthode <strong>{{ item()?.name }}</strong> ne sera plus proposée pour les nouveaux paiements.
  Les transactions existantes la référençant restent intactes.
</app-confirm-modal>
